import { normalizeTagValue } from '../../utils/tagUtils';

// Split raw tag groups from /api/posts/tags into the same three buckets the
// original sidebar used: subjects (default), geography, persons.
export const classifyGroups = (groups) => {
    const subjects = [];
    const geography = [];
    const persons = [];

    (Array.isArray(groups) ? groups : []).forEach((group) => {
        if (!group) {
            return;
        }
        const category = String(group.category || '').trim().toLowerCase();
        if (category === 'geography') {
            geography.push(group);
        } else if (category === 'persons') {
            persons.push(group);
        } else {
            subjects.push(group);
        }
    });

    return { subjects, geography, persons };
};

// Unique, alphabetized tags across a list of groups.
export const collectGroupTags = (groups) => {
    const canonical = new Map();

    (Array.isArray(groups) ? groups : []).forEach((group) => {
        (Array.isArray(group?.subTags) ? group.subTags : []).forEach((tag) => {
            const label = String(tag ?? '').trim();
            const normalized = normalizeTagValue(label);
            if (normalized && !canonical.has(normalized)) {
                canonical.set(normalized, label);
            }
        });
    });

    return [...canonical.entries()]
        .map(([value, label]) => ({ value, label }))
        .sort((a, b) => a.label.localeCompare(b.label, undefined, { sensitivity: 'base' }));
};

// Map of normalized tag -> number of posts carrying it.
export const countTagUsage = (posts) => {
    const counts = new Map();

    (Array.isArray(posts) ? posts : []).forEach((post) => {
        (Array.isArray(post?.tags) ? post.tags : []).forEach((tag) => {
            const normalized = normalizeTagValue(tag);
            if (normalized) {
                counts.set(normalized, (counts.get(normalized) || 0) + 1);
            }
        });
    });

    return counts;
};

// Single-tag links go to the clean archive page (/tag/:tag); the /tags
// browser keeps multi-select filtering via its ?sel= param.
export const tagLink = (tag) => `/tag/${encodeURIComponent(tag)}`;
